
export const SCHOOL_CLASSES = [
  "الأول",
  "الثاني",
  "الثالث",
  "الرابع",
  "الخامس",
  "السادس",
  "السابع",
  "الثامن",
  "التاسع",
  "العاشر",
  "الحادي عشر"
];

export const CLASS_BOOKS_MAP = {
  "الأول": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "الثاني": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "الثالث": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "الرابع": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "الخامس": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم", "معلوماتية",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "السادس": [
    "عربي", "رياضيات", "علوم", "اجتماعية", "ديانة", "موسيقا", "رسم", "معلوماتية",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "السابع": [
    "عربي", "رياضيات", "علوم", "فيزياء وكيمياء", "فرنسي", "تاريخ", "جغرافية", "ديانة", "رسم", "معلوماتية", "موسيقا",
    "انكليزي كتاب ايمار", "انكليزي دفتر أيمار"
  ],
  "الثامن": [
    "عربي", "هندسة", "جبر", "فيزياء وكيمياء", "علوم", "تاريخ", "جغرافية", "ديانة", "معلوماتية", "موسيقا", "رسم", "فرنسي",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ],
  "التاسع": [
    "عربي", "فيزياء وكيمياء", "جبر", "هندسة", "علوم", "تاريخ", "جغرافية", "ديانة", "معلوماتية", "موسيقا", "رسم", "فرنسي",
    "انكليزي كتاب ايمار", "انكليزي دفتر ايمار"
  ]
};
